const getWidthType = (width) => {
  if (width < 380) return 'sm';
  if (width < 500) return 'md';
  if (width < 766) return 'lx';
  return 'ex';
};

export default getWidthType;
